import { withZepetofulContent } from '@zep/next/server';
import { ZepetofulEntries } from '../../consts';
import { LegacyLandingPageView } from '../../views';
const LegacyLandingPage = () => {
  return <LegacyLandingPageView data-sentry-element="LegacyLandingPageView" data-sentry-component="LegacyLandingPage" data-sentry-source-file="landing.tsx" />;
};
export default LegacyLandingPage;
export const getStaticProps = withZepetofulContent(ZepetofulEntries.LANDING_PAGE);